import React from 'react';
import { sobreNos } from '../data/mockData';
import { CheckCircle2 } from 'lucide-react';

const Sobre = () => {
  return (
    <div className="sobre-page">
      <div className="sobre-hero">
        <h1>Sobre a Mordida de Sonho</h1>
        <p>Nossa história, missão e valores</p>
      </div>

      <div className="container">
        <section className="sobre-section">
          <div className="sobre-grid">
            <div className="sobre-imagem">
              <img
                src="https://images.unsplash.com/photo-1649436401481-f4128d7a3585?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwxfHxiYWtlcnklMjBwYXN0cmllc3xlbnwwfHx8fDE3NzM1NzY4NTV8MA&ixlib=rb-4.1.0&q=85"
                alt="Nossa Pastelaria"
              />
            </div>
            <div className="sobre-conteudo">
              <h2 className="sobre-titulo">Nossa História</h2>
              <p className="sobre-texto">{sobreNos.historia}</p>
            </div>
          </div>
        </section>

        <section className="missao-section">
          <div className="sobre-grid reverse">
            <div className="sobre-conteudo">
              <h2 className="sobre-titulo">Nossa Missão</h2>
              <p className="sobre-texto">{sobreNos.missao}</p>
            </div>
            <div className="sobre-imagem">
              <img
                src="https://images.unsplash.com/photo-1737700088869-66f1615d6c9a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHw0fHxiYWtlcnklMjBwYXN0cmllc3xlbnwwfHx8fDE3NzM1NzY4NTV8MA&ixlib=rb-4.1.0&q=85"
                alt="Nossa Missão"
              />
            </div>
          </div>
        </section>

        <section className="valores-section">
          <h2 className="section-title">Nossos Valores</h2>
          <div className="valores-grid">
            {sobreNos.valores.map((valor, index) => (
              <div key={index} className="valor-card">
                <CheckCircle2 className="valor-icon" />
                <p className="valor-texto">{valor}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="compromisso-section">
          <div className="compromisso-card">
            <h2>Nosso Compromisso</h2>
            <p>
              Na Mordida de Sonho, cada produto é preparado com dedicação e carinho.
              Utilizamos apenas ingredientes frescos e de alta qualidade, seguindo receitas
              tradicionais portuguesas que foram aperfeiçoadas ao longo dos anos.
            </p>
            <p>
              Acreditamos que a boa pastelaria é feita de detalhes, amor e tradição.
              Por isso, todos os nossos produtos são feitos diariamente, garantindo
              frescor e sabor incomparáveis.
            </p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Sobre;
